import * as React from 'react'

import { CompanySearchResultInterface } from '../../Interfaces/CompanySearchResultInterface'
import './CompanySearchResultRow.scss'

export const companySearchSupportedCountries = ['FR']

const getAddress = (row: CompanySearchResultInterface) => {
  const address =
    (row.address1 ? row.address1 : '') +
    (row.address2 ? ' ' + row.address2 : '') +
    ((row.address1 || row.address2) && row.city ? ',' : '') +
    (row.postcode ? ' ' + row.postcode : '') +
    (row.city && row.postcode ? ',' : '') +
    (row.city ? ' ' + row.city : '')
  return address !== '' ? <div className="company-search__results__company__address">{address}</div> : null
}

function highlightWords(line, word) {
  const regex = new RegExp('(' + word + ')', 'gi')
  return line.replace(regex, '<b>$1</b>')
}

const CompanySearchResultRow = (props) => {
  const row: CompanySearchResultInterface = props.data
  const { searchTerm } = props
  return (
    <div className="company-search__result-row">
      <div
        className="company-search__results__company__name"
        data-automation={'company-search-result'}
        dangerouslySetInnerHTML={{ __html: highlightWords(row.name, searchTerm) }}
      />
      {getAddress(row)}
    </div>
  )
}

export default CompanySearchResultRow
